export default {
  addRecipe: "Add Recipe",
  menuItem: "Menu Item",
  selectMenuItem: "Select menu item...",
  ingredient: "Ingredient",
  quantity: "Quantity",
  unit: "Unit",
  action: "Action",
  egOnion: "e.g. Onion",
  selectUnit: "Select unit",
  saveRecipe: "Save Recipe",
  pleaseSelectMenuItem: "Please select a Menu Item!",
  pleaseEnterIngredient: "Please enter at least one ingredient."
};